// extracted by mini-css-extract-plugin
export default {"container":"DevelopComponentPage_container__whu0d"};